import { render, staticRenderFns } from "./detail-item.vue?vue&type=template&id=7412e0cc&scoped=true"
import script from "./detail-item.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-item.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail-item.vue?vue&type=style&index=0&id=7412e0cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7412e0cc",
  null
  
)

export default component.exports